/**
 * Typed facade over localStorage — the only place where storage keys live
 * (enforced by the `no-restricted-globals` eslint rule). The key constants
 * keep their historic values so existing browser state survives.
 */
const KEYS = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  tenantSlug: 'tenantSlug',
  defaultSite: 'defaultSite',
  lignesTableColumnVisibility: 'lignes-table-column-visibility',
} as const;

export type StorageKey = keyof typeof KEYS;

export const storage = {
  get: (key: StorageKey): string | null => localStorage.getItem(KEYS[key]),
  set: (key: StorageKey, value: string): void =>
    localStorage.setItem(KEYS[key], value),
  remove: (key: StorageKey): void => localStorage.removeItem(KEYS[key]),
  /** Full wipe, UI prefs included — reserved for the unrecoverable paths. */
  clear: (): void => localStorage.clear(),
};
